var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClearCrossR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 27,
  height: 27,
  rx: 13.5,
  stroke: "black",
  strokeOpacity: 0.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.4853 9.86003L10.0377 17.4632C9.85078 17.6541 9.85078 17.9636 10.0377 18.1544C10.2247 18.3453 10.5278 18.3453 10.7148 18.1544L18.1624 10.5512C18.3494 10.3604 18.3494 10.0509 18.1624 9.86003C17.9754 9.66916 17.6723 9.66916 17.4853 9.86003Z",
  fill: "#171717"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9629 17.4488L10.5153 9.8456C10.3283 9.65473 10.0252 9.65473 9.83823 9.8456C9.65127 10.0365 9.65127 10.3459 9.83823 10.5368L17.2858 18.14C17.4728 18.3309 17.7759 18.3309 17.9629 18.14C18.1498 17.9491 18.1498 17.6397 17.9629 17.4488Z",
  fill: "#171717"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgClearCrossR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clear-cross-r.e1492d3519587eaf5454795efc495bd5.svg";